<script setup lang="ts">
import { defineAsyncComponent, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import FlipnovelGlobalHeader from './FlipnovelGlobalHeader.vue'
import { loadBrandConfig } from '@/utils/loadBrandConfig'
import { memberConfig as flipnovelConfig } from '@/pages/member/configs/flipnovel'
import { memberConfig as moonpageConfig } from '@/pages/member/configs/moonpage'
import { memberConfig as storlynConfig } from '@/pages/member/configs/storlyn'
import { memberConfig as novarisConfig } from '@/pages/member/configs/novaris'
import { memberConfig as noveluneConfig } from '@/pages/member/configs/novelune'

const route = useRoute()
const drawerOpen = ref(false)
const MemberDrawerPage = defineAsyncComponent(() => import('@/pages/member/components/MemberPage.flipnovel.vue'))
const memberDrawerConfig = loadBrandConfig({
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  novelune: noveluneConfig,
  storlyn: storlynConfig,
  novaris: novarisConfig,
})

watch(() => route.path, () => {
  drawerOpen.value = false
})

function openDrawer() {
  drawerOpen.value = true
}

function closeDrawer() {
  drawerOpen.value = false
}
</script>

<template>
  <div>
    <FlipnovelGlobalHeader @open-drawer="openDrawer" />

    <transition name="drawer-fade">
      <div v-if="drawerOpen" class="fixed inset-0 z-50" @click="closeDrawer">
        <div class="absolute inset-0 bg-black opacity-50" />
      </div>
    </transition>
    <transition name="drawer-slide">
      <div
        v-if="drawerOpen"
        class="fixed top-0 right-0 bottom-0 z-50 w-80vw max-w-320px bg-n-bg-global overflow-y-scroll"
      >
        <MemberDrawerPage :config="memberDrawerConfig" in-drawer @close="closeDrawer" />
      </div>
    </transition>
  </div>
</template>

<style scoped>
.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s ease;
}

.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.3s ease;
}

.drawer-slide-enter,
.drawer-slide-leave-to {
  transform: translateX(100%);
}
</style>
